import React from "react";
import logoFooter from "../../assets/logo-footer.svg";

export default function App() {
  const handlePrevent = (e) => {
    if (e?.currentTarget?.getAttribute("href") === "#") {
      e.preventDefault();
    }
  };

  return (
    <>
      <style>{`
        footer {
          margin-top: 10px;
          background: linear-gradient(
            90deg, 
            #1a7fe7 0%,
            #19c4c9 40%,
            #0ed079ff 100%
          );
          color: #fff;
          padding: 28px 0 30px;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1.25fr 1fr 0.8fr;
          gap: 22px;
          align-items: start;
        }

        .footer-brand {
          font-size: 38px;
          font-weight: 900;
          letter-spacing: -0.05em;
          margin-bottom: 14px;
        }

        .footer-brand span {
          color: #d7fffb;
        }

        .footer p,
        .footer a {
          font-size: 14px;
          line-height: 1.6;
          color: #effffc;
          text-decoration: none;
          opacity: 0.94;
        }

        .footer h4 {
          margin: 0 0 12px;
          font-size: 18px;
          letter-spacing: -0.02em;
        }

        .newsletter {
          display: flex;
          gap: 10px;
          align-items: center;
          margin-top: 6px;
        }

        .newsletter input {
          width: 100%;
          border: none;
          border-radius: 999px;
          padding: 12px 14px;
          outline: none;
          font-size: 13px;
        }

        .socials {
          display: flex;
          gap: 10px;
          margin-top: 16px;
        }

        .socials a {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: grid;
          place-items: center;
          background: rgba(255, 255, 255, 0.18);
          font-size: 16px;
        }

        footer {
          margin-top: 10px;
          background: linear-gradient(
            90deg, 
            #1a7fe7 0%,
            #19c4c9 80%
          );
          color: #fff;
          padding: 28px 0 30px;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1.25fr 1fr 0.8fr;
          gap: 22px;
          align-items: start;
        }

        .footer-brand {
          font-size: 38px;
          font-weight: 900;
          letter-spacing: -0.05em;
          margin-bottom: 14px;
        }

        .footer-brand span {
          color: #d7fffb;
        }

        .footer p,
        .footer a {
          font-size: 14px;
          line-height: 1.6;
          color: #effffc;
          text-decoration: none;
          opacity: 0.94;
        }

        .footer h4 {
          margin: 0 0 12px;
          font-size: 18px;
          letter-spacing: -0.02em;
        }

        .newsletter {
          display: flex;
          gap: 10px;
          align-items: center;
          margin-top: 6px;
        }

        .newsletter input {
          width: 100%;
          border: none;
          border-radius: 999px;
          padding: 12px 14px;
          outline: none;
          font-size: 13px;
        }

        .socials {
          display: flex;
          gap: 10px;
          margin-top: 16px;
        }

        .socials a {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: grid;
          place-items: center;
          background: rgba(255, 255, 255, 0.18);
          font-size: 16px;
        }

        .footer-content-width {
            max-width: 70%;
            margin-top: -50px
          }

        @media (max-width: 980px) { 
          .footer-grid {
            grid-template-columns: 1fr;
          }

          .footer-content-width {
            max-width: 100%
          }
      }
      `}</style>

      <footer className="footer">
        <div className="page footer-grid">
          <div className="footer-content-width">
            <div className="footer-brand" style={{ marginLeft: "-10px" }}>
              <img src={logoFooter} alt="Meu Ícone" width="200" />
            </div>
            <p style={{ marginTop: "-60px" }}>
              Somos um sistema inteligente, seguro, rápido e econômico de
              encontrar viajante em todo o mundo que possuem espaços disponíveis
              e que queiram levar sua encomenda ate o lugar que você deseja. Não
              somos empresa de transporte nem logística.
            </p>
          </div>

          <div>
            <h4>Página Institucional</h4>
            <p>
              <a href="#" onClick={handlePrevent}>
                Como funciona
              </a>
              <br />
              <a href="#" onClick={handlePrevent}>
                Quem somos
              </a>
              <br />
              <a href="#" onClick={handlePrevent}>
                Central de ajuda
              </a>
              <br />
              <a href="#" onClick={handlePrevent}>
                Perguntas frequentes - FAQ
              </a>
              <br />
              <a href="#" onClick={handlePrevent}>
                Trabalhe conosco
              </a>
              <br />
              <a href="#" onClick={handlePrevent}>
                Termos de uso
              </a>
            </p>
          </div>

          <div>
            <h4>Idioma</h4>
            <div className="newsletter">
              <input
                type="text"
                value="Português"
                aria-label="Idioma"
                readOnly
              />
            </div>
            <h4 style={{ marginTop: "16px" }}>Siga-nos nas redes sociais</h4>
            <div className="socials">
              <a href="#" onClick={handlePrevent}>
                in
              </a>
              <a href="#" onClick={handlePrevent}>
                f
              </a>
              <a href="#" onClick={handlePrevent}>
                x
              </a>
              <a href="#" onClick={handlePrevent}>
                ▶
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
